import CCFunnelChart from "../Common/CCFunnelChart";
import {prepareBuffer} from "../../util/Buffer";

class ExampleFunnelChart extends CCFunnelChart {
    constructor(props) {
        super(props);

        this.state.fetchBackgroundOperation = false
    };

    componentDidMount() {
        super.componentDidMount();

        const funnelData = [
            {value: 1000, label: 'Visitors'},
            {value: 600,  label: 'Sign-ups'},
            {value: 300,  label: 'Trials'},
            {value: 120,  label: 'Subscribers'},
            {value: 40,   label: 'Renewals'},
        ];

        let series = structuredClone(this.props.Series ?? [{}]);
        series[0].data = funnelData;

        this.setState({Loading: this.state.fetchBackgroundOperation, Series: series});

        this.applet.getEnterpriseComponent().executeQuery(1,100000);
    }

    enterpriseComponentLoadStarted = () => {
        this.setState({Loading: true});
    };

    enterpriseComponentLoadCompleted = (ec) => {
        let buffer = prepareBuffer(ec);

        let series = structuredClone(this.state.Series);
        if (series.length === 0) {
            series = [{data: []}]
        }
        series[0].data = []
        for (let i = 0; i < buffer.length; i++) {
            series[0].data.push({
                value: parseFloat(buffer[i].get("Y_AXIS_1")),
                label: buffer[i].get("X_AXIS"),
            });
        }

        this.setState({Loading: false, Series: series});
    };
}

export default ExampleFunnelChart;
